module.exports = __webpack_public_path__ + "img/is.c8b17430.svg";